export default __webpack_public_path__ + "static/media/testjig1.39e102d8.png";